module.exports = __webpack_public_path__ + "img/XH.5748fea2.png";